import { render } from "./AppItems.vue?vue&type=template&id=4523ca19"
import script from "./AppItems.vue?vue&type=script&lang=js"
export * from "./AppItems.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__